import { useRouteMatch } from 'react-router';

import { types } from './shared';
import { useActions, useAppContext } from '../../hooks';
import { usePrompts } from './usePrompts';
import { PromptsList } from './PromptsList';
import { PromptModal } from './PromptModal';
import { Button, Dropdown } from '../../components';
import { Form, FormItem, TopPanel } from '../../components';
import { addPrompt, updatePrompt, deletePrompt } from '../../api';
import type { Item, CreateItem, UpdateItem } from './usePrompts';

type ComponentProps = { campaignId: string };

const PromptsForCampaignComponent: React.FC<ComponentProps> = ({
  campaignId,
}) => {
  const { meta } = useAppContext();
  const campaign = meta.campaigns.find(item => item.value === campaignId);

  const listResult = usePrompts(campaignId);
  const { nodes, refresh, filters, setFilters, initializing } = listResult;

  const {
    isOpened,
    updating,
    initialValues,
    handleClose,
    handleAdd,
    handleEdit,
    handleStartAdd,
    handleStartEdit,
    handleStartDelete,
  } = useActions<Item, CreateItem, UpdateItem>({
    name: 'Prompt',
    onRefresh: refresh,

    onAdd: addPrompt,
    onEdit: updatePrompt,
    onDelete: deletePrompt,
  });

  return (
    <div className="flex flex-col gap-y-md w-full">
      {!!isOpened && (
        <PromptModal
          loading={updating}
          values={initialValues}
          onClose={handleClose}
          campaignId={campaignId}
          onSumbit={initialValues ? handleEdit : handleAdd}
        />
      )}
      <TopPanel>
        {!!campaign && (
          <div className="mr-auto flex items-center font-medium text-big truncate">
            Campaign: {campaign.label}
          </div>
        )}
        <Form<NonNullable<typeof filters>>
          initialValue={filters}
          onChange={setFilters}
        >
          <FormItem<NonNullable<typeof filters>> name="promptType" label="">
            <Dropdown placeholder="Type" grow={false} options={types} />
          </FormItem>
        </Form>
        <Button icon="plus" onClick={() => handleStartAdd()}>
          Add Prompt
        </Button>
      </TopPanel>
      <PromptsList
        data={nodes || []}
        updating={updating}
        initializing={initializing}
        onStartEdit={handleStartEdit}
        onStartDelete={handleStartDelete}
      />
    </div>
  );
};

const PromptsForCampaign = () => {
  const {
    params: { id },
  } = useRouteMatch<{ id: string }>();

  return id ? <PromptsForCampaignComponent campaignId={id} /> : null;
};

export default PromptsForCampaign;
